import { render, staticRenderFns } from "./LogoGifteryEs.vue?vue&type=template&id=5e64ba6b&scoped=true&"
import script from "./LogoGifteryEs.vue?vue&type=script&lang=js&"
export * from "./LogoGifteryEs.vue?vue&type=script&lang=js&"
import style0 from "./LogoGifteryEs.vue?vue&type=style&index=0&id=5e64ba6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64ba6b",
  null
  
)

export default component.exports